import React from "react";
import ButtonIcon from "../../../../../../components/buttons/ButtonIcon";
import { CleanIcon } from "../../../../../../components/buttons/IconButtons";
import DivContainerBody from "../../../../../../components/DivContainerBody";
import { FOODIE_CUSTOM_ACCESS_TABS, FOODIE_SHIFT_RESOURCE, STEPS_CREATE_FOODIE_SHIFT } from "../../Model/Models";
import { AddShiftResourceApp } from "../../Functionality/AddShiftResourceApp";
import { AssignedShiftResourceApp } from "../../Functionality/AssignedShiftResourceApp";
import TabPanel from "../../../../../../components/ResourceAssignment/TabPanel";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 *
 * Third foodie shift section: custom-access (employees) Add/Assigned tab panel.
 * Mirrors the attendance SectionCustomAccess.
 */
const SectionCustomAccess = ({
                                 id,
                                 handleClearStep,
                                 user,
                                 setUser,
                                 selectDeleteUser,
                                 setSelectDeleteUser,
                                 searchElement,
                                 setSearchElement,
                                 modified,
                                 setModified,
                                 mainContainerClass
                             }) => {
    return (
            <div className={"row mb-3"}>
                <div className='d-flex justify-content-end col-12 mb-2'>
                     {(id === null || typeof id === 'undefined') &&
                        <ButtonIcon
                            className='btn-clean-secondary-600'
                            id='btn_sca_clean_custom_access'
                            Icon={CleanIcon}
                            title={'clear_instances'}
                            onClick={() => handleClearStep(STEPS_CREATE_FOODIE_SHIFT.CUSTOM_ACCESS.INDEX)}
                            iconProps='btn-icon-svg-12px icon-color-general-00'
                        />
                    }
                </div>

                <div className={"col-12 mb-4"}>
                    <TabPanel
                        resource={FOODIE_SHIFT_RESOURCE.USERS}
                        tabsConfig={FOODIE_CUSTOM_ACCESS_TABS}
                        selected={user}
                        setSelected={setUser}
                        selectForDelete={selectDeleteUser}
                        setSelectForDelete={setSelectDeleteUser}
                        searchElement={searchElement}
                        setSearchElement={setSearchElement}
                        modified={modified}
                        setModified={setModified}
                        id={id}
                        deleteButtonId={'btn_sca_delete'}
                        useAddApp={AddShiftResourceApp}
                        useAssignedApp={AssignedShiftResourceApp}
                        mainContainerClass={mainContainerClass}
                    />
                </div>
            </div>
    );
}

export default SectionCustomAccess
